var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrchestrationJob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 3.5,
    fill: "#D6E3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.005 12.495C11.555 12.495 12.505 10.835 12.505 9.00501C12.505 7.20501 11.555 5.505 9.005 5.505C6.455 5.505 5.495 7.19501 5.495 9.00501C5.495 10.845 6.455 12.495 9.005 12.495ZM7.085 9.00501C7.085 7.535 7.545 6.745 9.005 6.745C10.465 6.745 10.925 7.535 10.925 9.00501C10.925 10.455 10.465 11.245 9.005 11.245C7.545 11.245 7.085 10.455 7.085 9.00501Z",
    fill: "#264EA0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 3.5,
    stroke: "#264EA0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrchestrationJob);
export default __webpack_public_path__ + "static/media/OrchestrationJob.6cfc420ab60da35e6c15e70e3be741f9.svg";
export { ForwardRef as ReactComponent };